
import TopFilterItem from '@/components/new/TopFilterItem.vue'
import ManagerScheduler from '@/components/new/schedulers/ManagerScheduler.vue';
import ContractorScheduler from '@/components/new/schedulers/ContractorScheduler.vue';
import ProjectsScheduler from '@/components/new/schedulers/ProjectsScheduler.vue';
import GET_PROJECTS from "@/apollo/scheduler/GetProjects.gql";

import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import DropdownOption from '@/entities/DropdownOption';
import Roles from '@/entities/Roles';
import { Company } from '@/interface';
import { User } from '@sentry/types'; import DateRange from "@/entities/scheduler/DateRange";

import moment from 'moment';

@Component({
    components: {
        TopFilterItem,
        ManagerScheduler,
        ContractorScheduler,
        ProjectsScheduler
    },
    apollo: {
        projects: {
            query: GET_PROJECTS,
            update: data => data.project,
            skip: true,
        }
    }
})
export default class CompanyScheduler extends Vue {
    @Prop({ type: Object, required: true }) readonly currentUser!: User;
    @Prop({ type: Object, required: true }) readonly company!: Company;

    sidenav: boolean = true;
    managers: any = [];
    contractors: any = [];
    showManagers: boolean = this.isAdmin ? true : false;
    showProjects: boolean = false;
    showContractors: boolean = this.isAdmin ? false : true;
    schedulerView = [this.managerViewOption];

    projects: any[] = [];
    selectedContractorsIds: string[] = [];
    selectedProjectsIds: string[] = [];
    selectedManagersIds: string[] = [];

    rangeStart: Date = new Date();
    rangeEnd: Date = moment(this.rangeStart).add(1, 'M').toDate();
    shouldClearFilters: boolean = false;
    showAdditionalFilters: boolean = false
    // placeHolderText: string = this.isAdmin ? "View by Managers" : "View by Contractors"
    placeHolderText: string = "Select"
    mounted() {

    }
    handleOptionChange(value: string) {
        //create switch case for each option
        switch (value) {
            case 'View by Contractors':
                this.clearAllOptions();
                this.showContractors = true;
                break;
            case 'View by Managers':
                this.clearAllOptions();
                this.showManagers = true;
                break;
            case 'View by Projects':
                this.clearAllOptions();
                this.showProjects = true;
                break;
        }
    }

    clearAllOptions() {
        this.showManagers = false;
        this.showProjects = false;
        this.showContractors = false;
    }

    @Watch("schedulerView")
    chooseView() {
        switch (this.schedulerView[0].id) {
            case "View by managers":
                this.switchToManagers();
                break;
            case "View by projects":
                this.switchToProjects();
                break;
            case "View by contractors":
                this.switchToContractors();
                break;
        }
    }
    get isAdmin(): boolean {
        return this.currentUser.role === Roles.ADMIN;
    }

    get showManagersSelect(): boolean {
        return this.showManagers && this.isAdmin;
    }

    get managerViewOption(): DropdownOption {
        return this.isAdmin
            ? { name: "View by managers", id: "View by managers" }
            : { name: "My schedule", id: "View by managers" };
    }

    get dateRange(): DateRange {
        return {
            startDate: this.rangeStart,
            endDate: this.rangeEnd,
        }
    }

    clearSelectedEntities(): void {
        this.selectedContractorsIds = [];
        this.selectedProjectsIds = [];
        this.selectedManagersIds = [];
    }

    switchToManagers(): void {
        this.clearSelectedEntities();
        this.showProjects = false;
        this.showContractors = false
        this.showManagers = true;
    }

    switchToProjects(): void {
        this.clearSelectedEntities();
        this.showManagers = false;
        this.showContractors = false;
        this.showProjects = true;
    }

    switchToContractors(): void {
        this.clearSelectedEntities();
        this.showManagers = false;
        this.showProjects = false;
        this.showContractors = true;
    }

    handleClearFilters(): void {
        this.shouldClearFilters = true;
    }

    handleFiltersReset(): void {
        this.shouldClearFilters = false;
        this.rangeStart = new Date();
        this.rangeEnd = moment(this.rangeStart).add(1, 'M').toDate();
    }

    handleManagerFiltersReset(): void {
        this.selectedManagersIds = [];
        this.handleFiltersReset();
    }

    handleProjectFiltersReset(): void {
        this.selectedProjectsIds = [];
        this.handleFiltersReset();
    }

    handleContractorFiltersReset(): void {
        this.selectedContractorsIds = [];
        this.handleFiltersReset();
    }

    toggleAdditionalFilters(): void {
        this.showAdditionalFilters = !this.showAdditionalFilters;
    }
}
